import { useFormContext, useWatch } from "react-hook-form";
import { Image, View } from "@/components/ui";
import {
  getGiftCardOccasionHeroImage,
  isGiftCardOccasionKey,
} from "@/containers/profile/account-gift-card/account-gift-card-history-component/lib";

import type { GiftCardFormData } from "./use-gift-card-form";

export function SectionGiftCardPreview() {
  const { control } = useFormContext<GiftCardFormData>();
  const [occasion] = useWatch({ control, name: ["occasion"] });
  const heroImage = getGiftCardOccasionHeroImage(
    isGiftCardOccasionKey(occasion) ? occasion : "gift-for-you",
  );
  return (
    <View className="native:w-screen px-4">
      <View className="mt-4 aspect-[361/202] w-full overflow-hidden rounded-2xl">
        <Image src={heroImage} className="native:h-auto web:h-full w-full" />
      </View>
    </View>
  );
}
